// App-wide design tokens — anything a second surface would otherwise re-declare.

// Loaded globally in public/index.html. Inter (the body face, src/config.ts) is not a
// token: naming it would duplicate the theme. MONO_FONT is for micro-labels and any
// figure that changes, where a fixed advance keeps columns from jittering.
export const DISPLAY_FONT = "'Instrument Sans', 'Inter', sans-serif";
export const MONO_FONT = "'IBM Plex Mono', ui-monospace, 'SF Mono', 'Roboto Mono', Menlo, monospace";

// The single panel recipe, so stacked cards on one page never disagree.
export const PANEL_SX = {
  border: '1px solid',
  borderColor: 'border.main',
  borderRadius: '20px',
  bgcolor: 'background.paper',
  boxShadow: (theme: { palette: { mode: string } }) =>
    theme.palette.mode === 'dark' ? 'inset 0 1px 0 rgba(255,255,255,0.03)' : 'inset 0 1px 0 rgba(255,255,255,0.6)'
} as const;

// Corner radii, so a card, its tiles and its buttons stay in scale.
export const RADIUS = {
  panel: '20px',
  card: '16px',
  control: '12px',
  tile: '10px',
  tag: '6px',
  pill: 999
} as const;

// Bare query for matchMedia / useMediaQuery; REDUCED_MOTION is the sx key form.
export const REDUCED_MOTION_QUERY = '(prefers-reduced-motion: reduce)';
export const REDUCED_MOTION = `@media ${REDUCED_MOTION_QUERY}`;

// Read by screen readers, not drawn. Strings on purpose: in sx a bare 1 on width/height means 100%.
export const SR_ONLY_SX = {
  position: 'absolute',
  width: '1px',
  height: '1px',
  margin: '-1px',
  padding: 0,
  border: 0,
  overflow: 'hidden',
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  whiteSpace: 'nowrap'
} as const;

// The header's round icon buttons (notifications, What's new, settings, support) and the slot each sits in.
export const HEADER_ICON_SLOT_SX = { flexShrink: 0, ml: 0.5 } as const;
export const HEADER_ICON_BUTTON_SX = { color: 'text.primary', bgcolor: 'transparent', '&:hover': { bgcolor: 'transparent' } } as const;

// Side drawers that cover the whole app, header and sidebar included (checkout, What's new).
export const OVERLAY_DRAWER_SX = { zIndex: (theme: { zIndex: { drawer: number } }) => theme.zIndex.drawer + 1000 } as const;
// Their paper: the theme makes drawer paper transparent (for the sidebar), so an overlay sets its own.
export const OVERLAY_DRAWER_PAPER_SX = { bgcolor: 'background.paper', backgroundImage: 'none' } as const;
